import React from "react";

import { ReactComponent as IconUser } from "../../../assets/images/AnswerList/icon_user.svg";
import { IAnswer } from "../../../state";
import { generateFullName } from "../../../libs/Util";
import OneAnswerBox from "../OneAnswerBox";

import styles from "./AnswerBox.module.scss";

export type AnswerBoxProps = {
  calling: boolean;
  studentNoInSchool: string;
  studentAnswers: IAnswer[];
  currentTeacherID: number;
  name_opened: boolean;
  classFullName?: string;
  isGroupAnswer?: boolean;
  isShowClassFullName?: boolean;
  isHighlighted?: boolean;
  handleLike: (answer_id: number) => void;
  handleComment: (
    content: string,
    answer_id: number,
    comment_id?: number,
  ) => void;
  handleToggleComment: (
    answer_id: number,
    comment_id: number,
    is_hidden: boolean,
  ) => void;
  handleDeleteComment: (answer_id: number, comment_id: number) => void;
};

const AnswerBox = React.forwardRef<HTMLDivElement, AnswerBoxProps>(
  (
    {
      calling,
      studentNoInSchool,
      studentAnswers,
      currentTeacherID,
      name_opened,
      classFullName,
      isGroupAnswer = false,
      isShowClassFullName,
      isHighlighted = false,
      handleLike,
      handleComment,
      handleToggleComment,
      handleDeleteComment,
    },
    ref,
  ) => {
    const className = isShowClassFullName ? `${classFullName} ` : "";

    return (
      <div className={styles.answer} ref={ref}>
        <p className={styles.name}>
          <IconUser />
          {name_opened ? (
            <>
              <span>
                {generateFullName([
                  studentAnswers[0].student.last_name,
                  studentAnswers[0].student.first_name,
                ])}
              </span>
              <span>{studentNoInSchool}</span>
            </>
          ) : (
            `${className}回答${studentAnswers[0].index}`
          )}
        </p>
        {studentAnswers.map(answer => (
          <OneAnswerBox
            key={answer.id}
            calling={calling}
            currentTeacherID={currentTeacherID}
            name_opened={name_opened}
            answer={answer}
            isGroupAnswer={isGroupAnswer}
            isHighlighted={isHighlighted}
            handleLike={handleLike}
            handleComment={handleComment}
            handleToggleComment={handleToggleComment}
            handleDeleteComment={handleDeleteComment}
          />
        ))}
      </div>
    );
  },
);

export default AnswerBox;
